import React, { useState } from 'react';
import { useIntl, useSelector, useDispatch, getLocale } from 'umi';
import { Modal, Button, Form, Input, Select } from 'tea-component';
import { ModalPrposType } from './ModalWrap';
import { addMenu, updateMenu } from '@/pages/dashboard/services/leftMenu';
import { useNameHooks, useMenuHooks, useNull, useFolderHooks } from './hooks';
export default (props: ModalPrposType) => {
  const { modalInfo: { show, type, item = {} }, close } = props;
  const [loading, setLoading] = useState<boolean>(false); // loading

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const locale = getLocale();
  // 名字相关
  const {
    nameCN,
    setNameCN,
    nameEN,
    setNameEN,
    nameENErr,
    setNameENErr,
    nameCNErr,
    checkNameEN,
    checkNameCN
  } = useNameHooks(item, formatMessage, 'subfolder');

  const { userInfo, currentGame, menuList, folderList } = useSelector(state => {
    // @ts-ignore
    const { currentGame, menuList, folderList } = state.dashboard;
    // @ts-ignore
    const { userInfo } = state.home;
    return {
      userInfo,
      currentGame,
      menuList,
      folderList
    }
  });

  // menu相关
  const {
    selectMenu,
    setSelectMenu,
    menuErr,
    formatMenuList,
    checkMenu
  } = useMenuHooks({ currentGame, item, menuList, locale, formatMessage });

  // folder相关
  const {
    selectFolder,
    setSelectFolder,
    folderErr,
    setFolderErr,
    formatFolderList,
    checkFolder
  } = useFolderHooks({ item, folderList, selectMenu, locale, formatMessage });

  const isNull = type === 'add' ? !nameEN || !selectMenu : !nameEN;
  const isError = nameENErr || nameCNErr || menuErr || folderErr;

  // 添加folder
  const doAddMenu = () => {
    if (!checkNameEN() || !checkNameCN() || !checkMenu() || !checkFolder() || loading) {
      return;
    }
    setLoading(true);
    const { game_code: gameCode, role_type: roleType, studio_code: studioCode } = currentGame || {};
    addMenu({
      menu_type: 3,
      u_parent_id: selectFolder ? selectFolder : '',
      name_en: nameEN,
      name_cn: nameCN,
      game_code: gameCode,
      role_type: roleType,
      studio_code: studioCode,
      user_id: userInfo?.userid
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
        payload: {
          currentGame
        }
      });
      close();
    }, (err) => {
      const { msg, code } = err;
      //本期只有一种状态 code：30011：代表重复，但是不能区分是哪个业务的重复，所以写不了配置文件，暂时在代码逻辑中处理
      const codeToMsg = code === 30011 ? formatMessage({ id: 'menu_subfolder_re_enter' }) : msg
      setNameENErr(codeToMsg);
    }).finally(() => {
      setLoading(false);
    });
  }

  // 更新folder
  const doUpdateMenu = () => {
    if (!checkNameEN() || !checkNameCN() || loading) {
      return;
    }
    setLoading(true);
    const { game_code: gameCode } = currentGame || {};
    updateMenu({
      name_en: nameEN,
      name_cn: nameCN,
      game_code: gameCode,
      u_id: item.id
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
        payload: {
          currentGame
        }
      });
      close();
    }, (err) => {
      const { msg, code } = err;
      //本期只有一种状态 code：30011：代表重复，但是不能区分是哪个业务的重复，所以写不了配置文件，暂时在代码逻辑中处理
      const codeToMsg = code === 30011 ? formatMessage({ id: 'menu_subfolder_re_enter' }) : msg
      setNameENErr(codeToMsg);
    }).finally(() => {
      setLoading(false);
    });
  }

  // 点击confirm 按钮
  const handleClickConfirm = () => {
    if (type === 'add') {
      doAddMenu();
    } else if (type === 'edit') {
      doUpdateMenu();
    }
  }

  return (
    <>
      <Modal.Body>
        <Form>
          <Form.Item
            showStatusIcon={false}
            required={true}
            label={formatMessage({ id: 'subfolder' }) + formatMessage({ id: 'name' })}
            status={nameENErr ? 'error' : undefined}
            message={nameENErr}>
            <Input style={{ width: '100%' }} value={nameEN} onChange={(val) => { setNameEN(val) }} onBlur={checkNameEN} placeholder={formatMessage({ id: 'menu_enter_subfolder_name' })} />
          </Form.Item>
          <Form.Item
            showStatusIcon={false}
            label={formatMessage({ id: 'chinese' }) + formatMessage({ id: 'name' })}
            status={nameCNErr ? 'error' : undefined}
            message={nameCNErr}>
            <Input style={{ width: '100%' }} value={nameCN} onChange={(val) => { setNameCN(val) }} onBlur={checkNameCN} placeholder={formatMessage({ id: 'menu_enter_subfolder_ch_name' })} />
          </Form.Item>
          {type === 'add' && <Form.Item
            showStatusIcon={false}
            required={true}
            label={formatMessage({ id: 'menu' })}
            status={menuErr ? 'error' : undefined}
            message={menuErr}>
            <Select
              size='full'
              matchButtonWidth={true}
              appearance="button"
              options={formatMenuList}
              value={selectMenu}
              onChange={value => setSelectMenu(value)}
              onBlur={checkMenu}
              placeholder={formatMessage({ id: 'common_select_placeholder' })}
            />
          </Form.Item>}
          {type === 'add' && <Form.Item
            showStatusIcon={false}
            required={true}
            label={formatMessage({ id: 'folder' })}
            status={folderErr ? 'error' : undefined}
            message={folderErr}>
            <Select
              size='full'
              matchButtonWidth={true}
              appearance="button"
              options={formatFolderList}
              value={selectFolder}
              onChange={value => setSelectFolder(value)}
              onBlur={checkFolder}
              placeholder={formatMessage({ id: 'common_select_placeholder' })}
              tips={
                formatFolderList.length == 0 ? formatMessage({ id: 'menu_select_no_data' }) : ''
              }
            />
          </Form.Item>}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={Boolean(isError) || isNull} loading={loading} type="primary" onClick={handleClickConfirm}>{formatMessage({ id: 'menu_confirm' })}</Button>
        <Button type="weak" onClick={close}>{formatMessage({ id: 'menu_cancel' })}</Button>
      </Modal.Footer>
    </>
  );
}
